import { render } from "./GlobalLoadingComponent.vue?vue&type=template&id=bdc73702&scoped=true&ts=true"
import script from "./GlobalLoadingComponent.vue?vue&type=script&lang=ts"
export * from "./GlobalLoadingComponent.vue?vue&type=script&lang=ts"

import "./GlobalLoadingComponent.vue?vue&type=style&index=0&id=bdc73702&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdc73702"]])

export default __exports__